declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
  }
}

const PIXEL_ID = '1722954068971040'

let initialized = false

export function initMetaPixel(): void {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  if (!window.fbq) {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    // Minimal fbq queue stub, matching the official Meta Pixel snippet behaviour.
    const queue: unknown[][] = []
    const fbq = (...args: unknown[]) => {
      queue.push(args)
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const anyFbq = fbq as any
    anyFbq.queue = queue
    anyFbq.loaded = true
    anyFbq.version = '2.0'
    anyFbq.push = fbq
    window.fbq = fbq as unknown as Window['fbq']
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(window as any)._fbq = window.fbq
  }

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')

  if (!document.getElementById('meta-pixel-noscript')) {
    const noscript = document.createElement('noscript')
    noscript.id = 'meta-pixel-noscript'
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1" alt="" />`
    document.body.appendChild(noscript)
  }
}

export function trackInitiateCheckout(): void {
  window.fbq?.('track', 'InitiateCheckout')
}
